module.exports = __webpack_public_path__ + "img/VN.608da377.png";